"use client";

import Link from "next/link";
import { useState } from "react";
import { primaryNavLinks } from "@/components/navLinks";

const mobileExtras = [
  { href: "/area-code-list", label: "Area Codes" },
  { href: "/auth/sign-in?next=%2Ffront-mate%2Fdashboard%2F", label: "Sign in" },
  { href: "/auth/sign-up?next=%2Ffront-mate%2Fdashboard%2F", label: "Sign up" },
];

export default function MobileNav() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="flex items-center gap-1.5 rounded-lg border border-line px-3 py-2 text-sm font-medium text-slate-600 transition-all hover:border-harbor/40 hover:bg-tide hover:text-harbor focus:outline-none focus:ring-2 focus:ring-harbor/20 md:hidden"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-label="Toggle navigation"
      >
        <svg
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          {open ? (
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
        Menu
      </button>

      {open && (
        <nav
          className="absolute inset-x-0 top-full z-40 border-b border-line bg-white p-2 shadow-lg md:hidden"
          aria-label="Mobile navigation"
        >
          {primaryNavLinks.map((link) => (
            <Link
              className="block rounded-lg px-3 py-2.5 text-sm font-medium text-slate-700 transition-colors hover:bg-tide hover:text-harbor"
              href={link.href}
              key={link.href}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          {mobileExtras.map((link) => (
            <Link
              className="block rounded-lg px-3 py-2.5 text-sm font-medium text-slate-700 transition-colors hover:bg-tide hover:text-harbor"
              href={link.href}
              key={link.href}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      )}
    </>
  );
}
